import React, { Component } from 'react';

import DadosCliente from './dadosCliente';

import './index.css';

export default class Venda extends Component {

  render() {
    return(
      <div className="cartPage">

        <div className="cartPageWrapper">

          <DadosCliente />

        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Views/Venda/index.js